import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

import { useNavigate } from 'react-router-dom';
import { useTranslation } from "react-i18next";

import { RouteList } from "@plannel/routeList";

const BackToSignIn = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  return (
    <Box sx={{ mt: 1.5, ml: "auto", mr: 1.5 }}>
      <Typography className="link-input" variant="body2" onClick={() => navigate(RouteList.Signin.path)}>{t("backToSignIn")}</Typography>
    </Box>
  )
}

export default BackToSignIn;